import React from "react";                                       // for JSX & React.useMemo
import { SelectColumnFilter, getFooterSum } from "../InventoryMovementsDetails.js"; 
 
const greenColumnHeaderHighlight = "rgba(0,200,0,.6)";
const redColumnHeaderHighlight   = "rgba(200,0,0,.6)";

export const closingInventoryTransactions = [
      {
        Header: "Item Id",
        label: "Item Id",
        Footer: "Total :",
        accessor: "item_id",
        value: "item_id",
        width: 90,
      },
      {
        Header: "Item Description || Brand",
        label: "Item Description || Brand",
        accessor: "desc_brand",
        value: "desc_brand",
        width: 180,
      },
     {
        Header: "Category 🔀",
        label: "Category",
        value: "category",
        accessor: "category",
        Filter: SelectColumnFilter,
        filter: (rows, id, filterValue, allFilters) => {
          if (!filterValue) return rows;
          // Find the sub-category filter value from allFilters
          const subCatFilter = allFilters?.find(f => f.id === "sub_category");
          const subCat = subCatFilter?.value || "All";
          return rows.filter(row => {
            const catMatch = row.values[id] === filterValue;
            const subMatch = subCat === "All" || row.values.sub_category === subCat;
            return catMatch && subMatch;
          });
        },
        width: 160,
      },
      {
        Header: "Sub Cat",
        label: "Sub Cat",
        value: "sub_category",
        accessor: "sub_category",
        Filter: SelectColumnFilter,
        filter: (rows, id, filterValue, allFilters) => {
          if (!filterValue) return rows;
          // Find the category filter value from allFilters
          const catFilter = allFilters?.find(f => f.id === "category");
          const cat = catFilter?.value || "All";
          return rows.filter(row => {
            const subMatch = row.values[id] === filterValue;
            const catMatch = cat === "All" || row.values.category === cat;
            return subMatch && catMatch;
          });
        },
        width: 160,
      },

          {
        Header: "Closing Inventory",
      
        Footer: (table) => {
          const total = getFooterSum(table, "closing_inventory");
          return Number(total)?.toLocaleString("en-IN"); // Format total with commas
        },
        label: "Closing Inventory ",
        accessor: "closing_inventory",
        value: "closing_inventory",
        width: 160,
        Cell: ({ value }) => {
    const number = Number(value);
    return isNaN(number) ? "N/A" : number.toLocaleString("en-IN");
      },
    },
      {
          Header: "Closing Inventory in KGs 🔀",
          label: "Closing Inventory in KGs",
          Footer: (table) => {
            const total = getFooterSum(table, "resultant_inventory_weight_closing");
            return Number(total)?.toLocaleString("en-IN");
          },
          accessor: "resultant_inventory_weight_closing",
          value: "resultant_inventory_weight_closing",
          disableSortBy: false,
          showSortIndicator: true,
          disableSortRemove: true,
          width: 160,
          Cell: ({ value }) => {
    const number = Number(value);
    return isNaN(number) ? "N/A" : number.toLocaleString("en-IN");
  },
        },
         {
            Header: "Closing Inventory Value 🔀",
            label: "Closing Inventory Value",
         
            Footer: (table) => {
              const total = getFooterSum(table, "closing_inventory_value");
              return Number(total)?.toLocaleString("en-IN");
            },
            accessor: "closing_inventory_value",
            value: "closing_inventory_value",
            disableSortBy: false,
            showSortIndicator: true,
            disableSortRemove: true,
            width: 160,
            Cell: ({ value }) => {
    const number = Number(value);
    return isNaN(number) ? "N/A" : number.toLocaleString("en-IN");
  },
          },


          

      {
        Header: "Last day Closing Inventory",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "last_day_closing_inventory"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        // Footer: table => getFooterSum(table, "last_day_closing_inventory"),
        Footer: (table) => {
          const total = getFooterSum(table, "last_day_closing_inventory");
          return Number(total)?.toLocaleString("en-IN"); // Format total with commas
        },
        label: "Last day Closing Inventory",
        accessor: "last_day_closing_inventory",
        value: "last_day_closing_inventory",
        Cell: ({ value }) => {
          const number = Number(value);
          return isNaN(number) ? "N/A" : number.toLocaleString("en-IN");
        },
        width: 120,
      },
    
      {
        Header: "Last day Inventory in KGs 🔀",
        label: "Last day Inventory in KGs",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "resultant_inventory_weight"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "resultant_inventory_weight"),
        accessor: "resultant_inventory_weight",
        value: "resultant_inventory_weight",
        disableSortBy: false,
        showSortIndicator: true,
        disableSortRemove: true,
        Cell: ({ value }) => {
          const number = Number(value);
          return isNaN(number) ? "N/A" : number.toLocaleString("en-IN");
        },
        width: 120,
      },
      {
        Header: "Last day Inventory Value 🔀",
        label: "Last day Inventory Value",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "inventory_value"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "inventory_value"),
        accessor: "inventory_value",
        value: "inventory_value",
        disableSortBy: false,
        showSortIndicator: true,
        disableSortRemove: true,
        Cell: ({ value }) => {
          const number = Number(value);
          return isNaN(number) ? "N/A" : number.toLocaleString("en-IN");
        },
        width: 120,
      },
      // New columns

  
      {
        Header: "GRN Qty",
        label: "GRN Qty",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "grn_qty"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "grn_qty"),
        accessor: "grn_qty",
        value: "grn_qty",
        bgColor: greenColumnHeaderHighlight,
      },
      {
        Header: "Depo Inward",
        label: "Depo Inward",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "child_grn"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "child_grn"),
        accessor: "child_grn",
        value: "child_grn",
        bgColor: greenColumnHeaderHighlight,
      },

      {
        Header: "Parent Qty Consumed",
        label: "Parent Qty Consumed",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "stock_transfer"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "stock_transfer"),
        accessor: "stock_transfer",
        value: "stock_transfer",
        bgColor: redColumnHeaderHighlight,
      },

   {
       Header: "Parent Production Balance",
       label: "Parent Production Balance",
       // Footer: (data) => {
       //   const total = React.useMemo(
       //     () => getFooterSum(data, "balance_qty_kgs"),
       //     [data.rows] "balance_qty_kgs"
       //   );
 
       //   return <>{total}</>;
       // },
       Footer: table => getFooterSum(table, "balance_qty"),
       accessor:  "balance_qty",
       value:  "balance_qty",
       bgColor: greenColumnHeaderHighlight,
     },

      {
        Header: "Child Qty Produced",
        label: "Child Qty Produced",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "converted_stock"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "converted_stock"),
        accessor: "converted_stock",
        value: "converted_stock",
        bgColor: greenColumnHeaderHighlight,
      },
      {
        Header: "Shipped Qty",
        label: "Shipped Qty",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "shipped_qty"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "shipped_qty"),
        accessor: "shipped_qty",
        value: "shipped_qty",
        bgColor: redColumnHeaderHighlight,
      },
      {
        Header: "Delivered Qty",
        label: "Delivered Qty",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "delivered_qty"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "delivered_qty"),
        accessor: "delivered_qty",
        value: "delivered_qty",
      },
      
      {
          Header: "Sample Qty",
          label: "Sample Qty",
          Footer: (data) => <>{getFooterSum(data, "sample_qty")}</>,
          accessor: "sample_qty",
          value: "sample_qty",
          bgColor: redColumnHeaderHighlight,
      },
      {
        Header: "Returned Qty",
        label: "Returned Qty",
        Footer: (data) => <>{getFooterSum(data, "returned_qty")}</>,
        accessor: "returned_qty",
        value: "returned_qty",
        bgColor: greenColumnHeaderHighlight,
      },
      {
        Header: "Customer old returns",
        label: "Customer old returns",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "customer_returns"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "customer_returns"),
        accessor: "customer_returns",
        value: "customer_returns",
        bgColor: greenColumnHeaderHighlight,
      },
      {
        Header: "Shipped to DC",
        label: "Shipped to Bhiwandi",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "shipped_to_parent"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "shipped_to_parent"),
        accessor: "shipped_to_parent",
        value: "shipped_to_parent",
        bgColor: redColumnHeaderHighlight,
      },
      {
        Header: "Shipped to depo",
        label: "Shipped to depo",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "shipped_to_child"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "shipped_to_child"),
        accessor: "shipped_to_child",
        value: "shipped_to_child",
        bgColor: redColumnHeaderHighlight,
      },
      {
        Header: "Return from depo",
        label: "Return from depo",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "return_from_child"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "return_from_child"),
        accessor: "return_from_child",
        value: "return_from_child",
        bgColor: greenColumnHeaderHighlight,
      },

      {
        Header: "Dumped Qty",
        label: "Dumped Qty",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "dumped_qty"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "dumped_qty"),
        accessor: "dumped_qty",
        value: "dumped_qty",
        bgColor: redColumnHeaderHighlight,
      },
      {
        Header: "Stock correction",
        label: "Stock correction",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "stock_correction"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "stock_correction"),
        accessor: "stock_correction",
        value: "stock_correction",
      },
      {
        Header: "Stock discrepancy",
        label: "Stock discrepancy",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "stock_discrepancy"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "stock_discrepancy"),
        accessor: "stock_discrepancy",
        value: "stock_discrepancy",
      },
      {
        Header: "Stock movement",
        label: "Stock movement",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "stock_movement"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "stock_movement"),
        accessor: "stock_movement",
        value: "stock_movement",
        bgColor: redColumnHeaderHighlight,
      },
      {
        Header: "Intransit transfer",
        label: "Intransit transfer",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "intransit_transfer"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "intransit_transfer"),
        accessor: "intransit_transfer",
        value: "intransit_transfer",
      },
      {
        Header: "Intransit return",
        label: "Intransit return",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "intransit_return"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: table => getFooterSum(table, "intransit_return"),
        accessor: "intransit_return",
        value: "intransit_return",
      },
      {
        Header: "isActive",
        label: "isActive",
        id: "isActive",
        accessor: "active_status",
        value: "active_status",
        Filter: SelectColumnFilter,
        // filter: "equals",
        filter: (rows, id, filterValue) => {
          if (filterValue === "All" || !filterValue) {
            return rows; // No filtering
          }
          return rows.filter(row => row.values[id] === filterValue); // Apply specific filtering
        },
      },
    ]